<nz-layout class="app-layout" [ngClass]="{'portals-route': router.url.startsWith('/portals')}">
  <nz-sider class="menu-sidebar" *ngIf="
      !router.url.startsWith('/sign') &&
      (router.url !== '/onboarding' && !router.url.startsWith('/onboarding/')) &&
      !router.url.startsWith('/quiz-taking') &&
      !router.url.startsWith('/signin') &&
      !router.url.startsWith('/signup') &&
      !router.url.startsWith('/reset-password') &&
      !router.url.startsWith('/phone-login') &&
      !router.url.startsWith('/new') &&
      !router.url.startsWith('/portals') &&
      router.url !== ''
    " nzCollapsible nzWidth="256px" nzBreakpoint="xl" [nzCollapsedWidth]="0" [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null">
    <div class="sidebar-logo">
      <a routerLink="/home">
        <!-- <img src="https://ng.ant.design/assets/img/logo.svg" alt="logo"> -->
        <!-- <h1 *ngIf="!isCollapsed">KnockVia</h1> -->
        <img *ngIf="!isCollapsed" src="../assets/logopurplenwhite.svg" alt="logo">
      </a>
    </div>
    <p *ngIf="currentUser && currentUser.active_company_name" class="portal-name" routerLink="/portals">{{
      currentUser.active_company_name }}</p>
    <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed" class="sidebar-menu">
      <li nz-submenu nzOpen nzTitle="Links" nzIcon="dashboard">
        <ul>
          <li nz-submenu nzTitle="Account & Portals" nzIcon="user">
            <ul>
              <li nz-menu-item nzMatchRouter><a routerLink="/home">Home</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/my-account">My Account</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/portals">Portals</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/leaderboard">Leaderboard</a></li>
            </ul>
          </li>
          <li nz-submenu nzTitle="Sales" nzIcon="dollar"
            *ngIf="hasProduct('Dish') || hasProduct('Starlink') || hasProduct('Fidium') || hasProduct('Ziply')">
            <ul>
              <li nz-menu-item nzMatchRouter *ngIf="hasProduct('Dish')"><a routerLink="/dish-flow">Dish Sale</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasProduct('Starlink')"><a routerLink="/starlink-flow">Starlink
                  Sale</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasProduct('Dish')"><a routerLink="/leads">Leads</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasProduct('Fidium')"><a routerLink="/manual-order">Manual Order</a>
              </li>
              <li nz-menu-item nzMatchRouter *ngIf="hasProduct('Ziply')"><a routerLink="/ziply-welcome-call">Ziply
                  Welcome Call</a></li>
            </ul>
          </li>
          <li nz-submenu nzTitle="Customers & Map" nzIcon="team">
            <ul>
              <li nz-menu-item nzMatchRouter><a routerLink="/customers">Customers</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/map">Map</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('pin-management')"><a
                  routerLink="/pin-management">Lead Management</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view-company-pins')"><a
                  routerLink="/company-pins">Lead List</a></li>
            </ul>
          </li>
          <li nz-submenu nzTitle="Pay" nzIcon="credit-card">
            <ul>
              <li nz-menu-item nzMatchRouter><a routerLink="/my-pending-pay">Pending Pay</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="!payCompDirectly()"><a routerLink="/my-pay-history">Pay History</a>
              </li>
              <li nz-menu-item nzMatchRouter *ngIf="payCompDirectly()"><a routerLink="/company-admin-payroll">Company
                  Admin Payroll</a></li>
            </ul>
          </li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_chat')">
            <a routerLink="/chat-service" class="nav-chat-link">
              <span>Chat</span>
              <span class="nav-unread-badge" *ngIf="chatUnreadCount > 0">
                {{ chatUnreadCount > 9 ? '9+' : chatUnreadCount }}
              </span>
            </a>
          </li>
          <li nz-submenu nzTitle="Learning & Recruiting" nzIcon="book"
            *ngIf="hasPermission('view_chat') || hasPermission('recruit_users') || true">
            <ul>
              <li nz-menu-item nzMatchRouter><a routerLink="/training-list">Training</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('recruit_users')"><a
                  routerLink="/recruiting">Recruiting</a></li>
            </ul>
            <!-- <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_chat')">
            <a routerLink="/chat-service" class="nav-chat-link">
              <span>Chat</span>
              <span class="nav-unread-badge" *ngIf="chatUnreadCount > 0">
                {{ chatUnreadCount > 9 ? '9+' : chatUnreadCount }}
              </span>
            </a>
          </li> -->
        </ul>
      </li>
      <li nz-submenu nzOpen nzTitle="Manager Tools" nzIcon="setting" *ngIf="showSubMenu('manager_tools')">
        <ul>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_imports')"><a routerLink="/imports">Imports</a></li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('see_all_dish_accounts')"><a
              routerLink="/dish-account-import">Dish Account Import</a></li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_groups')"><a routerLink="/groups">Groups</a></li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_users')"><a routerLink="/users">Users</a></li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_companies')"><a
              routerLink="/companies">Companies</a></li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_distributors')"><a
              routerLink="/distributors">Distributors</a></li>
          <!-- <li nz-menu-item nzMatchRouter *ngIf="hasPermission('manage_markets')"><a routerLink="/request-areas">Manage
              Markets</a></li> -->
          <!-- <li nz-submenu nzTitle="Marketing"
            *ngIf="hasPermission('manage_markets') || hasPermission('view_marketing_board')">
            <ul>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_marketing_board')"><a
                  routerLink="/marketing-board">Marketing Board</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('manage_markets')"><a
                  routerLink="/marketing-management">Marketing Management</a></li>
            </ul>
          </li> -->
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_quizzes')"><a routerLink="/quizzes">Manage
              Quizzes</a></li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_disposition_control')"><a
              routerLink="/disposition-control">Disposition Control</a></li>


          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_disposition_admin')"><a
              routerLink="/disposition-admin">Disposition Admin</a></li>

              
          <li nz-submenu nzTitle="Onboarding" nzIcon="unordered-list"
            *ngIf="hasPermission('view_onboarding_board') || hasPermission('view_onboarding_management')">
            <ul>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_onboarding_board')"><a
                  routerLink="/onboarding-board">Onboarding Board</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_onboarding_management')"><a
                  routerLink="/onboarding-management">Onboarding Management</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_onboarding_actions_management')"><a
                  routerLink="/onboarding-actions-management">Onboarding Actions</a></li>      
            </ul>
          </li>
        </ul>
      </li>
      <li nz-submenu nzOpen nzTitle="Admin" nzIcon="form" *ngIf="showSubMenu('admin_tools')">
        <ul>
          <li nz-submenu nzTitle="Pay Admin" nzIcon="dollar" *ngIf="hasPermission('manage_payroll')">
            <ul>
              <li nz-menu-item nzMatchRouter><a routerLink="/payplans">Payplans</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/payroll">Payroll</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/adjustments-admin">Adjustments Admin</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/duplicate-queue">Duplicate Queue</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/unassigned-customers">Unassigned Customers</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/manual-reviews">Chargeback/Cancels Review</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/payfile-review">Not On Master</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/discrepancies">Manual Discrepancies</a></li>
              <li nz-menu-item nzMatchRouter><a routerLink="/marketing-leads">Marketing Leads</a></li>
            </ul>
          </li>
          <li nz-submenu nzTitle="Providers & Payplans" nzIcon="bank"
            *ngIf="hasPermission('view_provider_payplans') || hasPermission('view_user_provider_payplans') || hasPermission('view_providers')">
            <ul>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_provider_payplans')"><a
                  routerLink="/provider-payplans">Provider Payplans</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_user_provider_payplans')"><a
                  routerLink="/user-provider-payplans">User Provider Payplans</a></li>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_providers')"><a
                  routerLink="/providers">Providers</a></li>
            </ul>
          </li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_training')"><a routerLink="/training">Training
              Admin</a></li>
          <li nz-submenu nzTitle="Document Management" nzIcon="file" *ngIf="showSubMenu('document_management')">
            <ul>
              <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_documents')"><a routerLink="/upload">Upload
                  Document</a></li>
            </ul>
          </li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_permissions')"><a
              routerLink="/permissions">Permissions</a></li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('manage_system_messages')"><a
              routerLink="/system-messages">System Messages</a></li>
          <li nz-menu-item nzMatchRouter *ngIf="checkAdmin()"><a routerLink="/pins-by-provider">Pins By Provider</a>
          </li>
          <li nz-menu-item nzMatchRouter *ngIf="checkAdmin()"><a routerLink="/background-queue">Background Queue</a>
          </li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_pFee_Queue')"><a
              routerLink="/processing-fee-queue">Processing Fee Queue</a></li>
          <li nz-menu-item nzMatchRouter *ngIf="hasPermission('view_states')"><a routerLink="/states">States</a></li>
        </ul>
      </li>
      <li nz-menu-item nzMatchRouter>
        <a (click)="logout()" routerLink="/signin">Logout</a>
      </li>
    </ul>
  </nz-sider>
  <nz-layout>
    <nz-header *ngIf="
        !router.url.startsWith('/sign') &&
        !router.url.startsWith('/onboarding') &&
        !router.url.startsWith('/signin') &&
        !router.url.startsWith('/signup') &&
        !router.url.startsWith('/reset-password') &&
        !router.url.startsWith('/phone-login') &&
        !router.url.startsWith('/new') &&
        !router.url.startsWith('/portals') &&
        router.url !== ''
      ">
      <div class="app-header">
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
          <span class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
        </span>
        <button *ngIf="isImpersonating()" nz-button nzType="primary" nzDanger (click)="stopImpersonating()"
          style="margin-right: 16px">
          <span nz-icon nzType="rollback" nzTheme="outline"></span>
          Stop Impersonating
        </button>
        <div class="header-actions">
          <button *ngIf="router.url.startsWith('/map')" nz-button nzType="primary" nzShape="circle"
            (click)="openMapFilter()">
            <span nz-icon nzType="filter" nzTheme="fill"></span>
          </button>
          <button nz-button nzShape="circle" nz-dropdown [nzDropdownMenu]="userMenu" nzTrigger="click">
            <span nz-icon nzType="user"></span>
          </button>
          <nz-dropdown-menu #userMenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item>
                <a routerLink="/my-account">My Account</a>
              </li>
              <li nz-menu-item>
                <a (click)="logout()" routerLink="/signin">Logout</a>
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </div>
    </nz-header>
    <nz-content [ngClass]="{
        'nz-content':
          !router.url.startsWith('/signin') &&
          !router.url.startsWith('/signup') &&
          !router.url.startsWith('/reset-password') &&
          !router.url.startsWith('/phone-login') &&
          !router.url.startsWith('/new') &&
          !router.url.startsWith('/portals') &&
          router.url !== ''
      }">
      <div [ngClass]="{
          'inner-content': !router.url.startsWith('/portals') &&
            !router.url.startsWith('/signin') &&
            !router.url.startsWith('/signup') &&
            !router.url.startsWith('/reset-password') &&
            !router.url.startsWith('/phone-login') &&
            !router.url.startsWith('/new') &&
            !router.url.startsWith('/portals') &&
            router.url !== ''
        }">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>